import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UseOfProceedsDraftUI from './UseOfProceedsDraftUI.js'

class UseOfProceedsDraftSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteSubmitted: false,
      selectedProceedsId: null,
      downloadSubmitted: false,
      downloadErrorList: null,
      //
      updateMode: false,
      deleteMode: false
    }
  }

  render() {
    return (
      <UseOfProceedsDraftUI
        loan={this.props.loan}
        context={this.props.context}
        onRefreshClick={this.props.onRefreshClick}
        //
        onDeleteSubmit={this.onDeleteSubmit}
        deleteSubmitted={this.state.deleteSubmitted}
        selectedProceedsId={this.state.selectedProceedsId}
        //
        onDownloadClick={this.onDownloadClick}
        downloadSubmitted={this.state.downloadSubmitted}
        downloadErrorList={this.state.downloadErrorList}
        //
        updateMode={this.state.updateMode}
        onUpdateClick={this.onUpdateClick}
        onUpdateCancel={() => { this.setState({ updateMode: false }) }}
        //
        onDeleteClick={this.onDeleteClick}
        deleteMode={this.state.deleteMode}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onUpdateClick = (event) => {
    let draftProceedsId = event.target.getAttribute('data-row-id')
    this.setState({
      updateMode: true,
      selectedProceedsId: draftProceedsId
    })
  }

  onDeleteClick = (event) => {
    let draftProceedsId = event.target.getAttribute('data-row-id')
    this.setState({
      successMsg: null,
      errorList: [],
      deleteMode: true,
      selectedProceedsId: draftProceedsId
    })
    RestApiUtils.delete(this.props.context,
      `/api/su/loan/${this.props.loan.loanId}/draftProceeds/${draftProceedsId}`,
      this.onDeleteClickCallback, {}
    )
  }

  onDeleteClickCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }
    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteMode: false
    })
    if (errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onDeleteSubmit = (event) => {
    event.stopPropagation()
    let deleteSubmitted = this.state.deleteSubmitted
    if (deleteSubmitted)
      return

    let proceedsId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      deleteSubmitted: true,
      selectedProceedsId: proceedsId
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/bills/${proceedsId}`, this.onDeleteCallback, {}
    )
  }

  onDeleteCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteSubmitted: false
    })

    if (errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onDownloadClick = (event) => {
    let proceedsId = event.currentTarget.getAttribute('data-id')
    this.setState({
      downloadErrorList: null,
      downloadSubmitted: true,
      selectedProceedsId: proceedsId
    })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/draftProceeds/${proceedsId}/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({
      downloadErrorList: response.errorList,
      downloadSubmitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default withRouter(UseOfProceedsDraftSF)
